import { makeVar } from "@apollo/client";

export const autoFocusAssumptionLocalVar = makeVar(false);
export const autoFocusDisbursementLocalVar = makeVar(false);
export const autoFocusExclusionLocalVar = makeVar(false);
export const autoFocusUpliftLocalVar = makeVar(false);
export const autoFocusDiscountLocalVar = makeVar(false);
export const autoFocusPhaseLocalVar = makeVar(false);
export const autoFocusTechnologyChargeLocalVar = makeVar(false);
